module.exports = __webpack_public_path__ + "img/step3-c.9f4497e5.png";